import { render, staticRenderFns } from "./matron_item.vue?vue&type=template&id=bb474044&scoped=true&"
import script from "./matron_item.vue?vue&type=script&lang=ts&"
export * from "./matron_item.vue?vue&type=script&lang=ts&"
import style0 from "./matron_item.vue?vue&type=style&index=0&id=bb474044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb474044",
  null
  
)

export default component.exports